export const cdnBucket = "r3z-cdn-us";
